<template>
    <ModalTemplate
        @openList="$emit('openList')"
        @close="$emit('close')"
        :closeBtn="true"
        :scrollBodyLock="true"
        mode="list"
    >
        <div class="list-mob-window">
            <div
                class="list-mob-window__wrapper"
                v-if="landPlotList && landPlotList.length"
            >
                <div
                    class="list-mob-window__item"
                    v-for="(item, i) in landPlotList"
                    :key="`list-mob-window-item-${item.id}`"
                    @click="openInDetailCardWindow(item.plot.number)"
                >
                    <div class="list-mob-window__item-header">
                        <h3 class="list-mob-window__item-header-title">
                            <span
                                class="list-mob-window__item-header-title-hl"
                                >{{
                                    item.house ? item.plot.name : 'Участок'
                                }}</span
                            >,
                            <span class="list-mob-window__item-header-address"
                                >{{ item.plot.street.name }},
                                {{ item.plot.houseNumber }}</span
                            >
                        </h3>
                    </div>
                    <p
                        class="list-mob-window__item-header-status"
                        :class="`list-mob-window__item-header-status--${item.plot.status}`"
                    >
                        <span v-if="item.plot.status === 'free'">
                            Свободен
                        </span>
                        <span v-else-if="item.plot.status === 'booked'">
                            Забронирован
                        </span>
                        <span v-else-if="item.plot.status === 'occupied'">
                            Занят
                        </span>
                    </p>
                    <div class="list-mob-window__item-body custom-list-mob">
                        <div
                            class="custom-list-mob__item"
                            v-if="item.house"
                        >
                            <p class="custom-list-mob__item-name">
                                Площадь дома, м2
                            </p>
                            <p class="custom-list-mob__item-value">
                                {{ item.house.area }}
                            </p>
                        </div>
                        <div class="custom-list-mob__item">
                            <p class="custom-list-mob__item-name">
                                Площадь участка, соток
                            </p>
                            <p class="custom-list-mob__item-value">
                                {{ item.plot.area }}
                            </p>
                        </div>
                        <div
                            class="custom-list-mob__item"
                            v-if="item.house && item.plot.parameters.length"
                        >
                            <p class="custom-list-mob__item-name">
                                Сроки сдачи
                            </p>
                            <p class="custom-list-mob__item-value">
                                {{ item.plot.parameters[0].value }}
                            </p>
                        </div>
                    </div>
                    <div class="list-mob-window__item-price">
                        <div
                            v-if="isSold(i)"
                            class="list-mob-window__item-price-set"
                        >
                            <div
                                class="list-mob-window__item-price-value list-mob-window__item-price-value--sold"
                            >
                                Продано
                            </div>
                        </div>

                        <template v-else>
                            <div
                                v-if="blackBoxPrice(i)"
                                class="list-mob-window__item-price-set"
                            >
                                <div
                                    class="list-mob-window__item-price-label"
                                    v-html="
                                        `Цена с ${switchCostLabel(
                                            blackBoxPrice(i),
                                            [
                                                `<b
                                >чистовой отделкой</b
                            >`,
                                                `отделкой <b>Black box</b>`,
                                            ],
                                        )}`
                                    "
                                ></div>
                                <div
                                    class="list-mob-window__item-price-value"
                                    v-html="
                                        `Цена с ${switchCostLabel(
                                            blackBoxPrice(i),
                                            [
                                                `<b
                                >чистовой отделкой</b
                            >`,
                                                `отделкой <b>White box</b>`,
                                            ],
                                        )}`
                                    "
                                ></div>
                            </div>
                            <div
                                v-if="whiteBoxPrice(i)"
                                class="list-mob-window__item-price-set"
                            >
                                <div class="list-mob-window__item-price-label">
                                    Цена от с отделкой <b>White box</b>
                                </div>
                                <div class="list-mob-window__item-price-value">
                                    {{ price(whiteBoxPrice(i) ?? 0) }} ₽
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div
                class="list-mob-window__void"
                v-else
            >
                <p class="list-mob-window__void-text">Не найдено участков</p>
            </div>
        </div>
    </ModalTemplate>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import ModalTemplate from '@/components/layouts/ModalTemplate.vue';
    import { landPlotStore } from '@/store/modules/LandPLot';
    import { cardSettingsStore } from '@/store/modules/CardSettings';
    import { cashSpacer } from '@/helpers/cashHelpers';
    import { switchCostLabel } from '@/helpers/costHelpers';

    const emits = defineEmits(['close', 'openInDetailCardWindow', 'openList']);

    const landPlotList = computed(() => {
        return landPlotStore.CURRENT_FILTERED_LAND_PLOTS;
    });

    function blackBoxPrice(index: number) {
        return landPlotList.value[index].plot.cost;
    }

    function whiteBoxPrice(index: number) {
        return landPlotList.value[index].plot.newCost;
    }

    const isSold = (index: number) => {
        const card = landPlotList.value[index].plot;

        return (!card?.cost && !card?.newCost) || card.status === 'occupied';
    };

    function price(data: number) {
        return cashSpacer(data, ' ');
    }

    async function openInDetailCardWindow(data: number | string) {
        emits('close');
        await landPlotStore.CREATE_LAND_PLOT_CARD_IN_MODAL(data);
        cardSettingsStore.LAND_PLOT_CARD_IN_MODAL_SET_SHOW_STATUS(true);
    }
</script>

<style lang="less">
    .list-mob-window {
        padding: 90px 64px 85px;

        @media (max-width: @size-mobile-top) {
            padding: 84px 24px 98px;
        }

        &__header {
            display: flex;
            height: 32px;
            align-items: center;
            margin-bottom: 41px;

            @media (max-width: @size-mobile-top) {
                margin-bottom: 33px;
            }
        }

        // .list-mob-window__old-price
        &__old-price {
        }
        // .list-mob-window__item
        &__item {
            padding: 0 24px;

            @media (max-width: @size-mobile-top) {
                padding: 0;
            }

            &:not(:last-child) {
                &::after {
                    content: '';
                    display: block;
                    height: 5px;
                    background-color: @second-gray;
                    margin: 25px -24px;
                }
            }

            // .list-mob-window__item-header
            &-header {
                margin-bottom: 10px;

                // .list-mob-window__item-header-title
                &-title {
                    font-size: 18px;
                    line-height: 24.3px;
                    color: @dark-brown;

                    &-hl {
                        color: @success;
                    }
                }
            }

            // .list-mob-window__item-body
            &-body {
            }

            // .list-mob-window__item-price
            &-price {
                display: flex;
                flex-direction: column;
                gap: 4px;
                margin-top: 8px;

                &-set {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                &-label {
                    font-family: Open Sans;
                    font-size: 12px;
                    color: @dark;
                }

                &-value {
                    margin-left: auto;
                    font-size: 16px;
                    line-height: 21.6px;
                    color: @success;

                    &--sold {
                        color: @medium-dark-gray;
                    }
                }
            }
        }

        &__item-header-status {
            .text-3-mobile();

            margin-bottom: 10px;

            @media (max-width: @size-mobile-top) {
                margin-bottom: 8px;
            }

            &--free {
                color: @success;
            }
            &--booked {
                color: @warning;
            }
            &--occupied {
                color: @danger;
            }
        }

        &__item-header-address {
            @media (max-width: @size-mobile-top) {
                display: block;
            }
        }

        // .list-mob-window__void
        &__void {
        }
    }

    .custom-list-mob {
        display: flex;
        flex-direction: column;
        gap: 4px;

        // .custom-list-mob__item
        &__item {
            .text-3-mobile();

            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: @second-gray;
            padding: 3px 16px 5px;

            @media (max-width: @size-mobile-top) {
                padding: 4px 10px;
            }
        }

        &__item-name {
            color: @medium-dark-gray;
        }

        &__item-value {
            color: @dark-brown;
        }
    }
</style>
